import type { AvailabilityConfidence } from '@teo/widget-shared';

/** One source contribution before merge. */
export type CartPartial = {
  source: string;
  confidence: AvailabilityConfidence;
  itemsCount?: number;
  cartValue?: number;
  currency?: string;
  /** True when the source explicitly reported an empty cart. */
  emptyExplicit?: boolean;
};

export const CART_SOURCE = {
  gtm: 'gtm-data-layer',
  shopify: 'shopify-cart-js',
  headerBadge: 'header-badge',
  cartPageDom: 'cart-page-dom',
} as const;

export function confidenceRank(value: AvailabilityConfidence): number {
  if (value === 'high') return 3;
  if (value === 'medium') return 2;
  return 1;
}
